<form class="popupForm" style="min-height: 300px;" [formGroup]="componentForm">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      <ng-container *ngIf="this.item">
        <span>{{'edit_training_event' | GetLabelPipe}}</span>
      </ng-container>
      <ng-container *ngIf="!this.item">
        <span *ngIf="this.trainerMode">{{'new_training_event' | GetLabelPipe}}</span>
        <span *ngIf="!this.trainerMode">{{'new_booking_event' | GetLabelPipe}}</span>
      </ng-container>
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="when-fx-layout-broke" style="min-height: 300px;">
      <div class="internal-spinner" *ngIf="state === 'loading'">
        <svg class="spinner" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
        </svg>
      </div>
      <div *ngIf="state === 'error'">
        >.< error. <br>{{errMsg}}
      </div>

      <div *ngIf="state==='edit'">
        <div fxLayout="row" fxLayoutAlign="start center" class="field-error-message"
             *ngIf="validationResult && !validationResult.isValid && validationResult.message">
          <mat-icon color="warn">error</mat-icon><span>{{ validationResult.message }}</span>
          <br>
        </div>

        <br>
        <div *ngIf="!profile">
          <button type="button" class="widerButton font16" mat-raised-button color="accent"
                  (click)="userPick()" [disabled]="pickItemsLoading">
            {{'pick_a_user' | GetLabelPipe}}
          </button>
        </div>

        <div *ngIf="profile">
          <div  class="file-row noselect" style="width: 100%; border: 0px;">
            <div matBadge="{{profile.itemFullData['rank']}}" matBadgeColor="accent">
              <img alt="" title="{{profile.name}}"
                   src="{{profile.picture_ava}}" class="list-item-image"
                   style="{{ profile.itemFullData.sex==='F' ? 'border-color: #FF1744' : 'border-color: #448AFF' }}"
              />
            </div>

            <div class="file-name noselect" style="width: 70%;">
              {{profile.name}}<br/>
              <div class="subrow subrow-trainer flex-row-center" *ngIf="profile['itemFullData']['shipping_phone']">
                <mat-icon style="width: 16px;">phone</mat-icon>&nbsp;&nbsp;&nbsp;+{{profile['itemFullData']['shipping_phone']}}
              </div>
            </div>

            <div class="file-menu" style="text-align: center">
              <button type="button" mat-raised-button color="accent"
                      [disabled]="state === 'loading'" [disabled]="pickItemsLoading" (click)="deleteUser()">
                {{'delete'|GetLabelPipe}}
              </button>
            </div>
          </div>
        </div>

        <br>
        <div class="flex-row-center flex-justify-space-between">
          <mat-slide-toggle formControlName="toggleTrainerControl" (change)="switchTrainerMode()">
            {{'toggle_trainer_booking' | GetLabelPipe}}
          </mat-slide-toggle>
        </div>

        <br>
        <div *ngIf="!trainerMode">{{'pick_package' | GetLabelPipe}}</div>
        <div *ngIf="trainerMode">{{'pick_training_package' | GetLabelPipe}}{{'trainera' | GetLabelPipe}}</div>
        <div class="flex-row-center flex-justify-start" style="gap: 4%;">

          <mat-form-field appearance="outline" color="accent" style="width: {{trainerMode ? '46%' : '80%'}}">
            <mat-select formControlName="trainerPackagesControl" (selectionChange)="packageChange()">
              <ng-container *ngFor="let trainerPackage of displayPackages; let i = index">
                <mat-option [value]="trainerPackage['id']">
                  <div class="flex-row-center">
                    <div>{{trainerPackage['name']}}</div>
                  </div>
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>

          <ng-container *ngIf="trainerMode && trainers && trainers.length">
            <mat-form-field appearance="outline" color="accent" style="width: 50%">
              <mat-label>{{'trainer' | GetLabelPipe}}</mat-label>
              <mat-select formControlName="trainersControl">
                <mat-option [value]="trainer" *ngFor="let trainer of trainers; let i = index">
                  <div class="flex-row-center">
                    <div>{{trainer['shipping_name']}}</div>
                  </div>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>

        </div>

        <br>
<!--        <div>{{'apply_service_checks' | GetLabelPipe}}</div>-->
        <div class="flex-row-center flex-justify-space-between">
          <mat-slide-toggle formControlName="applyUserServiceChecksControl" (change)="showServicesUsage()">
            {{'apply_service_checks' | GetLabelPipe}}
          </mat-slide-toggle>
        </div>
        <ng-container *ngIf="servicesUsageItemsDescription">
          <br>
          <div class="bordered-container" [innerHTML]="servicesUsageItemsDescription"></div>
        </ng-container>
        <br>
        <div>{{'event_start_time' | GetLabelPipe}}</div>
        <div class="flex-row-center flex-justify-space-between">
          <mat-form-field appearance="outline" color="accent" style="width: 33%">
            <input matInput [matDatepicker]="pickerStartDay" [disabled]="this.item ? true : false"
                   (click)="dateInputClick($event,pickerStartDay)"
                   (dateInput)="dateChangeEvent($event)"
                   formControlName="eventStartInput" #eventStartInputElem>
            <mat-datepicker-toggle matSuffix [for]="pickerStartDay"></mat-datepicker-toggle>
            <mat-datepicker [dateClass]="dateClass" touchUi #pickerStartDay></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" color="accent" style="width: 30%">
            <mat-label>{{'hours' | GetLabelPipe}}</mat-label>
            <mat-select formControlName="eventHourStart">
              <mat-option *ngFor="let hour of this.hours; let i = index" value="{{hour}}">{{hour}}</mat-option>
<!--              <ng-container *ngFor="let hour of this.hours; let i = index">-->
<!--                <option *ngIf="i < this.hours.length-1 " value="{{hour}}">{{hour}}</option>-->
<!--              </ng-container>-->
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" color="accent" style="width: 30%">
            <mat-label>{{'duration' | GetLabelPipe}}</mat-label>
            <mat-select formControlName="durationControl" (selectionChange)="durationChange()">
              <mat-option [value]="duration" *ngFor="let duration of durations; let i = index">
                <div class="flex-row-center">
                  <div>{{duration['label']}}</div>
                </div>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <ng-container *ngIf="calendarIDX == -1">
          <br><br>
        </ng-container>
        <ng-container *ngIf="calendarIDX != -1">
          <br>
          <div>{{'pick_court' | GetLabelPipe}}</div>
          <mat-radio-group matInput formControlName="courtIDXControl" aria-labelledby="example-radio-group-label"
                           class="radio-group">
            <mat-radio-button class="radio-button" *ngFor="let court of courts; let idx = index" [value]="idx">
              <div class="textCut">
                {{court['label']}}
              </div>
            </mat-radio-button>
          </mat-radio-group>
          <br>
        </ng-container>
      </div>
    </mat-dialog-content>

    <ng-container *ngIf="item?.extendedProps['schedule_type'] != 'training' && this.state !== 'loading'">
      <div *ngIf="this.state !== 'loading'" fxLayout="row" fxLayoutAlign="{{this.item ? 'space-between end' : 'end end'}}" fxLayoutGap="10px">
        <div *ngIf="this.item">
          <button type="submit" class="widerButton font16" mat-raised-button color="warn" (click)="deleteEvent()">
            {{'delete' | GetLabelPipe}}
          </button>
        </div>
        <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
          <button mat-button class="cancel widerButton font16" (click)="onNoClick()" *ngIf="!this.item">
            {{'cancel' | GetLabelPipe}}
          </button>
          <button type="submit" class="widerButton font16" mat-raised-button color="accent" (click)="handleSubmit()">
            {{'save' | GetLabelPipe}}
          </button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="item?.extendedProps['schedule_type'] == 'training' || this.state == 'loading'">
      <div fxLayout="row" fxLayoutAlign="{{this.item ? 'space-between end' : 'end end'}}" fxLayoutGap="10px">
        <div></div>
        <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
          <button mat-button class="cancel widerButton font16" (click)="onNoClick()">
            {{'cancel' | GetLabelPipe}}
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</form>
